// extracted by mini-css-extract-plugin
module.exports = {"Container":"Tooltip_Container__16Zsn","Tooltip":"Tooltip_Tooltip__2F7jy"};